export const testimonial = [
	{
		comment:
			"I’ve used this on a client’s site for almost 5 years and I have nothing but praise about it. It just does the job and never had any issues. Highly recommended.",
		name: "Pradeep",
		profileLink: "https://wordpress.org/support/users/pmaheepala/",
		profileImage:
			"https://secure.gravatar.com/avatar/567dcfbf43e4122bfa2cb055db04376cc1623b030ccbe56811ba2e56c9c946ad?s=100&d=retro&r=g",
		testimonialLink: "https://wordpress.org/support/topic/great-plugin-36818/",
		stars: 5,
	},
	{
		comment:
			"Awesome keep it up. The service you provide in the free version are really a saviour, it helped me very much. Thank you very much. God bless you guys!",
		name: "foodbazinga",
		profileLink: "https://wordpress.org/support/users/foodbazinga/",
		profileImage:
			"https://secure.gravatar.com/avatar/a125df575465a997d9450c03debe3beb5898231d3ca0864b58ce38f5a8577ced?s=100&d=retro&r=g",
		testimonialLink:
			"https://wordpress.org/support/topic/best-app-solved-a-huge-problem-great-customization-in-free-as-well/",
		stars: 5,
	},
	{
		comment:
			"Thank you for this beautiful ACCORDION & TABS plugin. I need something with just enough extensible options but not crazily over-styled. This was perfect. Thank you a hundred times over!",
		name: "treeflips",
		profileLink: "https://wordpress.org/support/users/treeflips/",
		profileImage:
			"https://secure.gravatar.com/avatar/698bbdf8465d26fb7054b19aa2e8663c52a1fa4e8b9363a13700c101a210066d?s=100&d=retro&r=g",
		testimonialLink:
			"https://wordpress.org/support/topic/best-developer-friendly-accordion-plugin/",
		stars: 5,
	},
];
